export default __webpack_public_path__ + "static/media/icon_speaker_stop.5e420553.svg";